export const environment = {
  production: true,
  useMocks: false,
  baseUrl: window.location.href.includes('absolut.ru') ? 'https://erp.nomia.app/graphql' : 'https://stage.erp.n.nomia.tech/graphql',
  storeDomain: '',
};
